import pDebounce from 'p-debounce';
import { useAsyncAbortable } from 'react-async-hook';
import { EMPTY_ARRAY } from '../../../shared/constants';
import { api } from './instance';

async function searchAddress(abortSignal, query) {
  query = query.trim();
  if (query) {
    const data = await api.auth
      .post('address/search', {
        signal: abortSignal,
        json: {
          searchTerm: query,
          maxResults: 20,
        },
      })
      .json();
    return Array.from(
      data
        .reduce((acc, { addressId, formattedAddress }) => {
          acc.set(addressId, { id: addressId, label: formattedAddress });
          return acc;
        }, new Map())
        .values(),
    );
  }
  return EMPTY_ARRAY;
}

const debouncedSearchAddress = pDebounce(searchAddress, 1000);

export function useAddressSearch(query) {
  return useAsyncAbortable(debouncedSearchAddress, [query]);
}
